export default __webpack_public_path__ + "static/media/GelBoxBuffer.9bfa3c28.svg";